import emitter from 'scripts/utils/emitter'
import * as cartRepository from 'scripts/api/cart'
import { addToCartDataLayer } from 'scripts/utils/data-layer'

import { tracker, findProductFromCart } from 'utils/app'

import { treatError } from './errors'

export default async (data, type) => {
  try {
    const response = await cartRepository.putProductsInCart(data)
    const shippingType = data.type

    const body = response.data
    const {
      uniqueProductsCount,
      shippings,
      total,
      subTotal,
      discountTotal,
      cheapestPayMethodTotal,
      services,
      paymentMethodsSummary,
      regionId,
      paymentMethods,
      servicesSubTotal,
      totalInstallments,
      totalDiscountsByType,
      firstCheapestPaymentMethod
    } = body

    const cart = {
      uniqueProductsCount,
      total,
      subTotal,
      discountTotal,
      cheapestPayMethodTotal,
      shippings,
      services,
      paymentMethods,
      paymentMethodsSummary,
      servicesSubTotal,
      totalInstallments,
      totalDiscountsByType,
      firstCheapestPaymentMethod
    }
    emitter.emit('cart:update', { count: body.uniqueProductsCount })
    emitter.emit('cart:products-added', cart)
    emitter.emit('product:data-layer', {
      storeName:
        shippings.find((shipping) => shipping.type === shippingType)?.items[0]
          .storeId || '',
      shippingType:
        shippingType === 'pickupInStore' ? 'pickup-in-store' : 'delivery'
    })

    const productsAddedToCart = shippings[0]?.items || []

    const isWishList = type === 'wishlist'

    if (isWishList) {
      const productsParams = productsAddedToCart.map((product) => ({
        productName: product.name,
        productId: product.productId,
        price: product.price.total,
        productBrand: product.brand,
        category: product.categoryTree,
        quantity: 1,
        dimension8: product.storeId ? 'pickup-in-store' : 'delivery',
        dimension9: product.storeId || '',
        dimension15: product.shopName
      }))

      addToCartDataLayer(productsParams, { regionId, sourceName: type })
    }

    const product = findProductFromCart(data.products[0].id, cart)

    const buildPrice = (packaging, price) => {
      const finalPrice = packaging * price

      return finalPrice.toFixed(2)
    }

    tracker.addToCart({
      cart: {
        value: cart.total,
        shipping_tier: product.storeId ? 'pickup-in-store' : 'delivery'
      },
      product: {
        item_id: product.productId || product.id,
        item_name: product.name,
        discount: product.price?.discount ?? 0,
        item_brand: product.brand,
        quantity: product.quantity,
        category: product.categoryTree,
        price: buildPrice(product.packaging, product.price?.to),
        currency: 'BRL',
        affiliation:
          product.shopName === 'Leroy Merlin'
            ? 'delivery: Leroy Merlin'
            : `pickup-in-store: ${product.shopName}`
      }
    })
  } catch (err) {
    treatError(err, data.type)
  }
}
